import styled from 'styled-components';
import { theme, toRem } from 'design';

export const SidebarHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: ${theme.zIndex.sidebar + 10};
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  min-height: ${toRem(theme.header.height)};
  padding: 0 ${toRem(theme.layout.gutter.small)};
  background-color: ${theme.color.neutral[50]};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding: 0 ${toRem(theme.layout.gutter.large)};
  }

  @media (min-width: ${theme.breakpoint.large}px) {
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    min-height: auto;
    padding: ${toRem(44)} ${toRem(33)} ${toRem(33)};
  }
`;

export const SidebarHeaderTitle = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;

  @media (min-width: ${theme.breakpoint.large}px) {
    width: 100%;
  }
`;
